// NPM Imports
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
// import { useDispatch, useSelector } from "react-redux";
// import { Loader } from "../../revvComponents";

// Components Imports
import MetaFieldViewAccordion from "./MetaFieldViewAccordion";
import MetaFieldView from "./MetaFieldView";

// Actions Imports
import { fetchMetaFieldAction } from "../../actions/MetaFieldActions";
import GTM_EVENTS from "../../gtm/gtmevents";
// Internal Imports

// Destructuring

// Declarations
const LOCAL_META_FIELD = "custom_mf";
const GLOBAL_META_FIELD = "global_mf";

const MetaField = ({
  mode,
  templateObjectId,
  documentObjectId,
  fetchMetaFields,
  metaGroups,
  templatedIdInDoc,
}) => {
  // state
  const [activePaneView, updatePaneView] = useState(LOCAL_META_FIELD);
  const docMode = templateObjectId ? "templates" : "documents";
  const objectId = templateObjectId || documentObjectId;
  useEffect(() => {
    fetchMetaFields(docMode, objectId);
  }, []);

  const META_FIELD_PANES = [
    {
      id: GLOBAL_META_FIELD,
      label: "Template details",
      icon: ["far", "info-circle"],
      gtmAction:
        mode === "DOCUMENT"
          ? GTM_EVENTS.DOCUMENTVIEW_DOCUMENT_DETAILS_CLICK
          : GTM_EVENTS.TEMPLATEVIEW_TEMPLATE_DETAILS_CLICK,
    },
    {
      id: LOCAL_META_FIELD,
      label: "Meta fields",
      icon: ["far", "credit-card"],
      gtmAction:
        mode === "DOCUMENT"
          ? GTM_EVENTS.DOCUMENTVIEW_METAFIELDS_DETAILS_CLICK
          : GTM_EVENTS.TEMPLATEVIEW_METAFIELDS_DETAILS_CLICK,
    },
  ];

  return (
    <div className="metafield-pane-container animated fadeinright">
      {/* ---- MetaField pane header section -----  */}
      <div className="metafield-pane-header">
        <span className="metafield-pane-title">Metadata</span>
      </div>
      {/* ---- MetaField accordion view section -----  */}
      <div className="metafield-body-wrapper">
        <MetaFieldViewAccordion
          activePaneView={activePaneView}
          toggleCurrentView={updatePaneView}
          metaFieldPanes={META_FIELD_PANES}
          mode={mode}
        />
      </div>
      {/* ---- MetaField view details section -----  */}
      <div className="metafield-paneview-container">
        <MetaFieldView
          currentView={activePaneView}
          mode={mode}
          templatedIdInDoc={templatedIdInDoc}
          metaGroups={metaGroups}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const {
    customDynamicFieldData,
    template: { object_id: templateObjectId },
  } = state.TemplateStore;
  const {
    document: { objectId: documentObjectId, template_id: templatedIdInDoc },
  } = state.DocumentStore;
  const { metaGroups } = state.MetaFieldStore;
  return {
    customDynamicFieldData,
    templateObjectId,
    documentObjectId,
    metaGroups,
    templatedIdInDoc,
  };
};

const mapDispatchToProps = { fetchMetaFields: fetchMetaFieldAction };

export default connect(mapStateToProps, mapDispatchToProps)(MetaField);
